<template>
  <div class="pr-1 pl-1">
    <div class="no-gutters mt-2 ml-3 mr-3">
      <div class="row pl-2 pb-1" v-if="'commands' in this.$route.query && campaignType(selectedCampaign) === this.CAMPAIGN_TYPE_INPROGRESS">
        <div class="col-md-12">
          <b-button class="btn btn-xs" variant="secondary" v-on:click="sendPing(widget, platformId)">Ping</b-button>
          <b-button class="btn btn-xs ml-1" variant="secondary" v-on:click="requestMessage(widget, platformId, 143)">Request state</b-button>
          <b-dropdown size="xs" variant="secondary" text="Intervals" class="ml-1">
            <b-dropdown-item-button v-on:click="setIntervals(widget, platformId, 0)">Set monitoring intervals</b-dropdown-item-button>
            <b-dropdown-item-button v-on:click="setIntervals(widget, platformId, 1)">Set reporting intervals</b-dropdown-item-button>
          </b-dropdown>
          <b-dropdown size="xs" variant="secondary" text="Position calibration" class="ml-1">
            <b-dropdown-item-button v-on:click="widget.$root.$emit('startPositionCalibration', platformId)">Start position calibration</b-dropdown-item-button>
            <b-dropdown-item-button v-on:click="widget.$root.$emit('stopPositionCalibration', platformId)">Stop position calibration</b-dropdown-item-button>
            <b-dropdown-item-button v-on:click="applyPositionEstimate(widget, platformId)">Apply position estimate</b-dropdown-item-button>
          </b-dropdown>
          <b-button class="btn btn-xs ml-1" variant="danger" disabled>Open releaser</b-button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="parameter-box">
            <div v-if="latitude !== 0 && longitude !== 0 || !calibrationRunning">
              <h5 v-b-popover.hover.bottom="latitude + ', ' + longitude">{{ position }}</h5>
              <div class="parameter-name">Current position (<strong>manual</strong>)</div>
            </div>
            <div v-else>
              <h5 v-b-popover.hover.bottom="latitude_estimate + ', ' + longitude_estimate">{{ position_estimate }}</h5>
              <div class="parameter-name">Current position (<strong>estimated</strong>)</div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="parameter-box">
            <h4 v-if="position_source !== null">
              {{ position_source }}
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Position source</div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="parameter-box">
            <h4 v-if="dive_stage !== null">
              {{ dive_stage }}
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Dive stage</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="parameter-box">
            <h4 v-if="depth !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 4)" title="Show depth in chart and map">{{ showDigits(roundDigits(depth, 1), 1) }}</a> <small>m</small>
              <font-awesome-icon v-if="velocity_z < 0" size="sm" class="ml-1 align-baseline" :icon="['fas', 'long-arrow-alt-up']" />
              <font-awesome-icon v-if="velocity_z > 0" size="sm" class="ml-1 align-baseline" :icon="['fas', 'long-arrow-alt-down']" />
              <span v-if="velocity_z !== 0" class="text-muted align-middle velocity-z">
                <a href="#" class="parameter-link" @click="selectParameter(1, 7)" title="Show velocity z in chart and map">{{ roundDigits(Math.abs(velocity_z), 1) }}</a> <small>m/s</small>
              </span>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Depth</div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="parameter-box">
            <h4 v-if="altitude !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 5)" title="Show altitude in chart and map">{{ showDigits(roundDigits(altitude, 1), 1) }}</a> <small>m</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Altitude</div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="parameter-box">
            <h4 v-if="releaser_state !== null">
              {{ releaser_state }}
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Releaser state</div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="parameter-box">
            <h4 v-if="battery_voltage !== null">
              <a href="#" class="parameter-link" @click="selectParameter(3, 1)" title="Show battery voltage in chart and map">{{ showDigits(roundDigits(battery_voltage, 1), 1) }}</a> <small>V</small>
              <font-awesome-icon class="text-success align-baseline" rotation="270" size="xs" v-if="battery_voltage > 25" :icon="['fas', 'battery-full']" />
              <font-awesome-icon class="text-success align-baseline" rotation="270" size="xs" v-else-if="battery_voltage > 22 && battery_voltage <= 25" :icon="['fas', 'battery-three-quarters']" />
              <font-awesome-icon class="text-warning align-baseline" rotation="270" size="xs" v-else-if="battery_voltage > 20 && battery_voltage <= 22" :icon="['fas', 'battery-half']" />
              <font-awesome-icon class="text-warning align-baseline" rotation="270" size="xs" v-else-if="battery_voltage > 18 && battery_voltage <= 20" :icon="['fas', 'battery-quarter']" />
              <font-awesome-icon class="text-danger align-baseline" rotation="270" size="xs" v-else-if="battery_voltage < 18" :icon="['fas', 'battery-empty']" />
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Battery voltage</div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-gutters mt-3 mb-3 ml-4 mr-4">
      <div class="row">
        <div class="col-md-3">
          <div class="state-box" :class="getStateStyle(battery_warning)">
            Battery
          </div>
        </div>
        <div class="col-md-3">
          <div class="state-box" :class="getStateStyle(modem_error)">
            Modem
          </div>
        </div>
        <div class="col-md-3">
          <div class="state-box" :class="getStateStyle(depth_error)">
            Pressure
          </div>
        </div>
        <div class="col-md-3">
          <div class="state-box" :class="getStateStyle(software_error)">
            Software
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import Helpers from '@/mixins/helpers'
import BelugaMessageFactory from '@/mixins/beluga_messagefactory'

const CAMPAIGN_TYPE_INPROGRESS = 1
const NAVIGATION = 1
const CALIBRATION = 50 // FIXME: Reorganize IDs

export default {
  name: 'TransponderDashboardWidget',
  mixins: [
    Helpers,
    BelugaMessageFactory
  ],
  data: function () {
    return {
      CAMPAIGN_TYPE_INPROGRESS: CAMPAIGN_TYPE_INPROGRESS,
      widget: this,
      calibrationInitialized: false,
      calibrationRequested: false
    }
  },
  props: ['platformId'],
  mounted: function () {
    // Initialize flag
    this.calibrationInitialized = this.calibrationRunning
  },
  watch: {
    calibrationRunning: function (newValue) {
      if (newValue) {
        this.calibrationRequested = false
      }
    }
  },
  methods: {
    ...mapMutations(['select_parameter']),
    getStateStyle: function (state) {
      if (state) {
        return 'state-danger'
      } else {
        return 'state-ok'
      }
    },
    rotateArrow: function (heading) {
      return 'rotate(' + Number(Number(heading) - 45) + 'deg)'
    },
    applyPositionEstimate: function (widget, platformId) {
      // Disable positioning first
      widget.$root.$emit('stopPositionCalibration', platformId)
      // Send command to update position
      this.updateTransponderPosition(widget, platformId, this.latitude_estimate, this.longitude_estimate)
    },
    selectParameter: function (entityId, parameterId) {
      this.select_parameter([this.platformId, entityId, parameterId])
    }
  },
  computed: {
    ...mapState(['platforms', 'selectedCampaign']),
    ...mapGetters(['currentUpdate', 'lastUpdate', 'campaignType']),
    calibrationRunning () {
      return this.fixes_current !== this.fixes_required
    },
    progressbarState () {
      if (this.calibrationInitialized) {
        if (this.calibrationRunning) {
          return 2 // Ongoing calibration
        } else {
          if (this.calibrationRequested) {
            return 1 // Calibration requested, but no fix received yet
          } else {
            return 3 // Calibration finished
          }
        }
      }
      return 0
    },
    // progressbarValue () {
    //   if (this.progressbarState > 1) {
    //     return this.fixes_current
    //   }
    //   return 0
    // },
    // progressbarMax () {
    //   if (this.progressbarState > 1) {
    //     return this.fixes_required
    //   }
    //   return 0
    // },
    position () {
      const position = this.getCoordinatesNautical(this.roundDigits(this.latitude, 5),
        this.roundDigits(this.longitude, 5))
      return position.lat + ' ' + position.lng
    },
    position_estimate () {
      const position = this.getCoordinatesNautical(this.roundDigits(this.latitude_estimate, 5),
        this.roundDigits(this.longitude_estimate, 5))
      return position.lat + ' ' + position.lng
    },
    latitude () {
      const update = this.currentUpdate(this.platformId, NAVIGATION, 1)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    longitude () {
      const update = this.currentUpdate(this.platformId, NAVIGATION, 2)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    depth () {
      const update = this.currentUpdate(this.platformId, NAVIGATION, 4)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    latitude_estimate () {
      const update = this.currentUpdate(this.platformId, CALIBRATION, 1)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    longitude_estimate () {
      const update = this.currentUpdate(this.platformId, CALIBRATION, 2)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    depth_estimate () {
      const update = this.currentUpdate(this.platformId, CALIBRATION, 4)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    fixes_current () {
      const update = this.currentUpdate(this.platformId, CALIBRATION, 7)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    fixes_required () {
      const update = this.currentUpdate(this.platformId, CALIBRATION, 8)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    altitude () {
      const update = this.currentUpdate(this.platformId, 1, 5)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    velocity_z () {
      const update = this.currentUpdate(this.platformId, 1, 7)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    dive_stage () {
      const update = this.currentUpdate(this.platformId, 4, 1)
      if (update.length !== 0) {
        return this.capitalizeFirstLetter(update[1])
      }
      return '-'
    },
    position_source () {
      const update = this.currentUpdate(this.platformId, 1, 8)
      if (update.length > 1 && isNaN(update[1])) {
        update[1] = update[1].replace('_', ' ')
        return update[1] !== 'USBL' ? this.capitalizeFirstLetter(update[1]) : update[1]
      }
      return '-'
    },
    releaser_state () {
      const update = this.currentUpdate(this.platformId, 4, 3)
      if (typeof update[1] !== 'undefined') {
        return this.capitalizeFirstLetter(update[1])
      }
      return '-'
    },
    battery_voltage () {
      const update = this.currentUpdate(this.platformId, 3, 1)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    battery_warning () {
      const update = this.currentUpdate(this.platformId, 3, 2)
      return (update.length !== 0) ? update[1] : false
    },
    modem_error () {
      const update = this.currentUpdate(this.platformId, 2, 2)
      return (update.length !== 0) ? update[1] : false
    },
    depth_error () {
      const update = this.currentUpdate(this.platformId, 2, 3)
      return (update.length !== 0) ? update[1] : false
    },
    software_error () {
      const update = this.currentUpdate(this.platformId, 2, 4)
      return (update.length !== 0) ? update[1] : false
    }
  }
}
</script>

<style lang="scss" scoped>

.btn-drop .btn {
  font-size: 40px;
  font-weight: bold;
}

.parameter-box {
  padding: 10px 0 0 10px;
}
.parameter-box h4 {
  margin-bottom: 2px;
}
.parameter-box h5 {
  margin-bottom: 2px;
}
.parameter-name {
  font-size: 11px;
  color: #6c757d;
}
.state-box {
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  vertical-align: bottom;
  border-radius: 2px;
  padding: 5px 2px 5px 2px;
}
.state-ok {
  background-color: #82E0AA;
  color: #186A3B;
}
.state-danger {
  background-color: #F1948A;
  color: #78281F;
}
.no-gutters {
  margin-right: 10px;
  margin-left: 10px;
  .col,
  [class*="col-"] {
    padding-right: 2px;
    padding-left: 2px;
  }
}

.velocity-z {
  font-size: 15px;
}
</style>
